var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStacked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.5 36H22.5V31H33.5V36ZM40 36H36.5V31H40V36ZM19.5 36H10V31H19.5V36ZM40 15L32.5 15V10L40 10V15ZM29.5 15H26.5V10H29.5V15ZM23.5 15H10V10H23.5V15ZM40 25.5H26.5V20.5H40V25.5ZM23.5 25.5H20.5V20.5H23.5V25.5ZM17.5 25.5H10L10 20.5H17.5V25.5Z",
    fill: "#1F2F3D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStacked);
export default __webpack_public_path__ + "static/media/stacked.f56c9b14b726d8a0c085fdcbb1c5c75a.svg";
export { ForwardRef as ReactComponent };